import { connect } from "react-redux";
import ScopeSelector from "../../Components/GenericComponent/ScopeSelector";

const mapStateToProps = (state) => ({
    SCOPES: state.reducer.SCOPES,

});
const mapDispatchToProps = (dispatch) => ({
  
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ScopeSelector);